import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.stylus = bracketIndenting()
